<template>
 <div>
<!-- home
<el-button type="primary">测试</el-button>
<pt-time-slot></pt-time-slot>
<pt-page-title title="655685" :isSearch="true" @search="search">
     <el-button type="primary" slot="before-left">添加</el-button>
</pt-page-title>
<pt-page-menu-filter :tabs="menus" v-model="menu"></pt-page-menu-filter>
<el-pagination
  small
  layout="prev, pager, next"
  :total="50">
</el-pagination>
<img src="@/assets/svg-icon/bold.svg" alt="">
<p>
  d
</p>
<p>
  d
</p>
<p>
  d
</p>
<p>
  d
</p><p>
  d
</p>
<p>
  d
</p>
<p>
  d
</p>
<p>
  d
</p>
<p>
  d
</p>
<p>
  d
</p> -->
 </div>
</template>

<script>
export default {
  data () {
    return {
      menus: [
        {
          label: '全部订单',
          value: 'all'
        },
        {
          label: '待退款',
          value: 'refund'
        }
      ],
      menu: 'all'
    }
  },
  components: {

  },
  methods: {
    search (val) {
      console.log(12)
    }
  },
  created () {
    console.log('当前登陆人信息：', this.$auth.user())
  }
}
</script>

<style>
</style>
